var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarDummy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 35.4375C27.068 35.4375 34.875 27.6305 34.875 18C34.875 8.36953 27.068 0.5625 17.4375 0.5625C7.80703 0.5625 0 8.36953 0 18C0 27.6305 7.80703 35.4375 17.4375 35.4375Z",
    fill: "#E6ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4304 28.3921C29.8041 26.2148 27.6924 24.4468 25.263 23.2287C22.8337 22.0106 20.1537 21.3759 17.4361 21.375C14.7185 21.3741 12.0382 22.0072 9.60807 23.2238C7.17798 24.4404 5.06516 26.207 3.4375 28.3833C5.05688 30.5706 7.16625 32.3481 9.59649 33.5731C12.0267 34.7981 14.7102 35.4367 17.4317 35.4375C20.1533 35.4384 22.8371 34.8015 25.2681 33.578C27.6991 32.3545 29.8096 30.5784 31.4304 28.3921Z",
    fill: "#4294FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 19.125C21.1654 19.125 24.1875 16.1029 24.1875 12.375C24.1875 8.64708 21.1654 5.625 17.4375 5.625C13.7096 5.625 10.6875 8.64708 10.6875 12.375C10.6875 16.1029 13.7096 19.125 17.4375 19.125Z",
    fill: "#4294FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDummy);
export default __webpack_public_path__ + "static/media/avatar-dummy.827d2944a8eb471f282eed56e9b0ff0a.svg";
export { ForwardRef as ReactComponent };